<template>
  <div class="TiptapEditorBox">
    <tiptap-vuetify
      class="textAreaTag"
      v-model="content"
      ref="tiptapEditor"
      :native-extensions="nativeExtensions"
      @input="onInput"
    >
    </tiptap-vuetify>
    <v-menu
      top
      :position-x="selectionX"
      :position-y="selectionY"
      :z-index="999"
      :content-class="'courseTagMenu'"
      :value="searchResult">
      <v-list>
        <v-list-item 
          link 
          v-for="course in searchResult"
          @click="selectCourse(course)"
          :key="course.id"
        >
          <v-list-item-title v-html="course.html">
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import {
  TiptapVuetify
} from "tiptap-vuetify";
import TiptapCourseTag from "@/components/Tiptap/TiptapCourseTag.js";
import { debounce } from "@/utils/helper";
export default {
  name: "TextAreaTag",
  components: {TiptapVuetify},
  props: {
    value: { type: String, default: '' },
    label: { type: String, default: '' },
  },
  data() {
    return {
      content: '',
      nativeExtensions: [new TiptapCourseTag()],
      searchString: null,
      currentPage: 1,
      totalPages: 0,
      searchResult: [],
      searchTimeout: null,
      selectionX: null,
      selectionY: null
    };
  },
  methods: {
    setInputEditor(data) {
      this.$emit('input', data.val)
    },
    onInput(content, info) {
      const {parent, parentOffset} = info.state.selection.$anchor
      const inputText = parent.textContent.substring(0, parentOffset)
      const symbolIndex = inputText.lastIndexOf('@')
      if(symbolIndex !== -1) {
        const chunks = inputText.substring(symbolIndex).split(' ')
        if(chunks.length === 1
          || (chunks.length === 2 && chunks[1] === '')
        ) {
          this.selectionParent = parent
          this.searchString = chunks[0].replace('@', '')
          clearTimeout(this.searchTimeout);
          this.searchTimeout = setTimeout(this.searchCourse, 500)
          return
        }
      }
      this.resetSearchParam()
    },
    async searchCourse(page = 1) {
      this.currentPage = page;
      const beforeSearchString = this.searchString
      const result = await this.$store.dispatch('searchCourse', {
        text: this.searchString,
        page, limit: window.cordova ? 3 : 5
      });
      if(this.searchString !== beforeSearchString) {
        return
      }
      this.totalPages = result.totalPages;
      if(result.list.length === 0 ) {
        this.resetSearchParam();
        return
      }
      result.list.forEach(course => {
        if(!course.name) return;
        if(!this.searchString) return;
        const string = this.searchString.replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase())
        if(course.name.indexOf(string) !== -1) {
          course.html = course.name.replace(string, '<span class="primary--text">' + string + '</span>');
        } else {
          course.html = course.name.replace(this.searchString, '<span class="primary--text">' + this.searchString + '</span>');
        }
      });
      const {x, y} = this.getCaretPosition();
      this.selectionX = x - 8*(this.searchString.length+1);
      this.selectionY = y - 5;
      if(result.currentPage === 1) {
        this.searchResult = result.list;
        return
      }
      this.searchResult = this.searchResult.concat(result.list);
    },
    selectCourse(course) {
      this
      .$refs["tiptapEditor"]
      .editor.commands
      .courseTag({
        href: course.country.slug + 'gammarSplitter' + course.slug,
        innerText: '@' + course.name.replace(/\s/g, ''),
        searchTerm: '@' + this.searchString
      });
      this.resetSearchParam()
    },
    resetSearchParam() {
      this.searchString = null
      this.currentPage = 1,
      this.totalPages = 0,
      this.searchResult = [],
      this.searchTimeout = null
    },
    getCaretPosition() {
      let x = 0;
      let y = 0;
      const sel = window.getSelection();
      if(sel.rangeCount) {
        const range = sel.getRangeAt(0).cloneRange();
        if(range.getClientRects()) {
          range.collapse(true);
          const rect = range.getClientRects()[0];
          if(rect) {
              y = rect.top;
              x = rect.left;
          }
        }
      }
      return {x, y};
    }
  },
  mounted() {
    this.content = this.value
  },
  watch: {
    content: {
      handler(val) {
        this.$emit("input", val);
      },
    },
    value: {
      handler(val) {
        if(this.value !== this.content) {
          this.content = this.value
        }
      },
    },
  },
};
</script>
<style lang="scss">
.TiptapEditorBox {
  position: relative;
  .textAreaTag {
    .ProseMirror {
      margin: 8px !important;
      p {
        margin-top: 8px !important;
        margin-bottom: 8px !important;
      }
    }
  }
}
.courseTagMenu {
  box-shadow: 0 0 2px rgba(0,0,0,0.5) !important;
  .v-list-item {
    min-height: unset;
    .v-list-item__title {
      height: 32px;
      line-height: 32px;
      .primary--text {
        text-decoration: underline;
      }
    }
  }
}
</style>
